import React from 'react'
import { t } from 'ttag'

import { Box } from 'components/layout/Box/Box'
import { Logo } from 'components/shared/Logo/Logo'
import { Button } from 'components/shared/Button/Button'
import { DoubleConfirmationModal } from 'components/modals/DoubleConfirmationModal/DoubleConfirmationModal'
import {
  InterviewHandlersContext,
  InterviewStateContext,
} from 'components/modules/interview/context'
import { toInterview } from 'ducks/router'
import { useContext } from 'hooks'

import { ArrowLeftIcon } from 'components/shared/Icon/model'

import styles from './Header.module.scss'

export const Header = () => {
  const state = useContext(InterviewStateContext)!
  const handlers = useContext(InterviewHandlersContext)!

  const {
    candidate: { name, project_name },
    current_status,
    id,
    steps,
    user,
    isIntroductionStep,
    isReportStep,
    isSummaryStep,
    isConfirmSubmitOpen,
    isValid,
    isEditMode,
  } = state
  const {
    handleChangeStep,
    handleInterviewClose,
    handleConfirmSubmitClose,
    handleConfirmSubmitOpen,
    closeModalAndValidate,
  } = handlers

  const userName = `${user?.first_name} ${user?.last_name}`

  return (
    <Box
      className={styles.header}
      direction="column"
      justify="flex-start"
      tagName="header"
    >
      <Box align="center" className={styles.top} justify="space-between">
        <Logo
          className={styles.logo}
          redirectTo={toInterview({ uuid: id })}
          isTransparent
        />
        <span aria-label="user" className={styles.profile} role="presentation">
          {userName}
        </span>
      </Box>
      <Box align="center" className={styles.bottom} justify="space-between">
        <Box align="center" className={styles.heading} justify="flex-start">
          <Button
            ariaLabel="back"
            className={styles.back}
            icon={ArrowLeftIcon}
            size="medium"
            variant="text"
            onClick={handleInterviewClose}
          />
          {!isIntroductionStep ? (
            <h1 className={styles.title}>
              {t`Interview: ${name} for ${project_name}`}
            </h1>
          ) : null}
        </Box>
        <Box align="center" className={styles.actions} justify="flex-end">
          {isIntroductionStep ? (
            <Button
              className={styles.action}
              color="primary"
              label={t`Start the interview`}
              size="medium"
              variant="filled"
              onClick={() => handleChangeStep(steps[0].key)}
            />
          ) : null}
          {!isIntroductionStep || isReportStep ? (
            <Button
              className={styles.action}
              label={
                isReportStep
                  ? current_status === 5
                    ? t`Go to final results`
                    : t`Go to interviews`
                  : t`Cancel interview`
              }
              size="medium"
              variant="outlined"
              onClick={handleInterviewClose}
            />
          ) : null}
          {isSummaryStep || isEditMode ? (
            <Button
              className={styles.action}
              color="primary"
              label={isEditMode ? t`Submit changes` : t`Submit assessments`}
              size="medium"
              variant="filled"
              onClick={
                isValid ? handleConfirmSubmitOpen : closeModalAndValidate
              }
            />
          ) : null}
          {
            <DoubleConfirmationModal
              onCancel={handleConfirmSubmitClose}
              onClose={handleConfirmSubmitClose}
              onConfirm={closeModalAndValidate}
              isOpen={isConfirmSubmitOpen}
              cancelLabel={t`Close`}
              confirmLabel={t`Confirm`}
              text={
                isEditMode
                  ? t`Are you sure you want to submit these changes?`
                  : t`Are you sure you want to submit this assessment?`
              }
              title={t`Submit?`}
              message={t`Submitted data will influence candidate's score`}
            />
          }
        </Box>
      </Box>
    </Box>
  )
}
